/* eslint-disable eqeqeq */
import React from "react";
import { uniqueId, toPascalCase } from "../../../utility/common-methods.jsx";
import { FILTER_NAMES, VERTICALS } from "../../../constants/app-constant";
import { RemoveIcon, AddIcon } from "../../Icons/icons.component";
import { useSelector } from "react-redux";
const {
  EDITION,
  SOURCE_TYPE,
  TONALITY,
  ZONE,
  CATEGORY,
  VERTICAL,
  PRESS_RELEASE,
  COUNTRIES,
  LANGUAGES,
  CHANNELS_LIST,
  CHART_TYPE,
} = FILTER_NAMES;

export const FilterItem = ({
  filterOption,
  selectedFilter,
  setSelectedFilter,
  handleFilterSelect,
  filters,
  disabled,
  isAddWidgetPage,
  showNone,
  forceMultiSelect = false,
  showSelectedAll,
}) => {
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const {
    name = "",
    values = [],
    multiselect = forceMultiSelect || true,
  } = filterOption || {};

  let tName =
    name.toLowerCase() == "tonality_mult" || name.toLowerCase() == "sentiment"
      ? "tonality"
      : name.toLowerCase();
  const targetFilter = filters[tName];

  const isChecked = (name, type) => {
    try {
      if (targetFilter) {
        if (Array.isArray(targetFilter) && type) {
          return (
            targetFilter.indexOf(type.toString()) !== -1 ||
            targetFilter.indexOf(type) !== -1 ||
            targetFilter.filter((el) => el.id == type)[0]
          );
        } else {
          return targetFilter == type;
        }
      }
      return false;
    } catch (e) {
      return false;
    }
  };

  const isSelectedAllChecked = () => {
    try {
      let tName =
        name.toLowerCase() == "tonality_mult" ? "tonality" : name.toLowerCase();
      return filters[tName].length === values.length;
    } catch (e) {
      return false;
    }
  };

  const getFaceValue = (name, values) => {
    if (!values) {
      return name;
    }
    let faceValue = name;

    switch (name) {
      case EDITION:
        const fv = values.filter((el) => el.id == filters.edition)[0];
        faceValue = fv && fv.edition_name;
        break;
      case TONALITY:
        const tonality = values.filter((el) => el.id == filters.tonality)[0];
        faceValue = tonality && tonality.tone;
        break;
      case VERTICAL:
        const vertical = values.filter((el) => el.id == filters.media_type)[0];
        faceValue = vertical && vertical.type_name;
        break;
      case CATEGORY:
        const ctg = values.filter((el) => el.id == filters.category)[0];
        faceValue = ctg && ctg.description;
        break;
      case ZONE:
        const tempZone = values.filter((el) => el.id == filters.zone)[0];
        faceValue = tempZone && tempZone.zone;
        break;
      case SOURCE_TYPE:
        const st = values.filter((el) => el.id == filters.source_type)[0];
        faceValue = st && st.text;
        break;
      case COUNTRIES:
        const cntry = values.filter((el) => el.value == filters.country)[0];
        faceValue = cntry && cntry.country_name;
        break;

      default:
        faceValue = name;
    }
    return toPascalCase(faceValue || name);
  };

  const handleSelect = (e) => {
    let setterValue = undefined;
    const val = e.target.value;
    if (name === TONALITY) {
      //https://webonise.atlassian.net/browse/CB-614
      const correctedTone = val == "Neutral" ? "Informative" : val;
      const selectedTone = values.filter((el) => el.id == correctedTone)[0];
      setterValue = selectedTone && selectedTone.id;
    }
    if (name === EDITION) {
      const selectedCity = values.filter((el) => el.edition_name == val)[0];
      setterValue = selectedCity && selectedCity.id;
    }
    if (name === ZONE) {
      const selectedZone = values.filter((el) => el.zone == val)[0];
      setterValue = selectedZone && selectedZone.id;
    }
    if (name === CATEGORY || name === PRESS_RELEASE) {
      const selectedCtg = values.filter((el) => el.description == val)[0];
      setterValue = selectedCtg && selectedCtg.id;
    }
    if (name === VERTICAL) {
      const selectedEnt = values.filter((el) => el.type_name == val)[0] || {};
      setterValue = selectedEnt && selectedEnt.id;
    }
    if (name === SOURCE_TYPE) {
      const selectedSource = values.filter((el) => el.text == val)[0] || {};
      setterValue = selectedSource && selectedSource.id;
    }

    if (name === COUNTRIES) {
      const selectedCountry = values.filter((el) => el.value == val)[0] || {};
      setterValue = selectedCountry && selectedCountry.value;
    }
    if (name === CHANNELS_LIST) {
      const selectedChannel = values.filter((el) => el.channel_name == val)[0] || {}
      setterValue = selectedChannel && selectedChannel.id;
    }
    if (name === "JOURNALIST") {
      const selectedReporter = values.filter((el) => el.anchor_name == val)[0] || {}
      setterValue = selectedReporter && selectedReporter.id;
    }
    if (name === LANGUAGES) {
      const selectedLanguage = values.filter((el) => el.language == val)[0] || {}
      setterValue = selectedLanguage && selectedLanguage.id;
    }
    if (name === CHART_TYPE) {
      const selectedChartType = values.filter((el) => el.value == val)[0] || {}
      setterValue = selectedChartType && selectedChartType.value;
    }
    if (name === "State") {
      const selectedState = values.filter((el) => el.state == val)[0] || {}
      setterValue = selectedState && selectedState.id;
    }
    const resetAll = val == "reset";
    handleFilterSelect(name, setterValue, resetAll);
  };

  const handleSelectedOption = (id, label) => {
    try {
      if (name === 'CHART_TYPE') {
        if (label === selectedFilter) {
          return true;
        }
        else
          return false;
      }
      return filters[name.toLowerCase()] == id;
    } catch (e) {
      return false;
    }
  };

  const handleSelectedAllClick = () => {
    handleFilterSelect(
      name,
      "",
      isSelectedAllChecked(),
      !isSelectedAllChecked()
    );
  };

  const isSelected = (name === 'CHART_TYPE') ? handleSelectedOption(1, selectedFilter) : selectedFilter == name;
  const label = toPascalCase(name);
  const title = getFaceValue(name, values);

  const isFilterPopulated = () => {
    if (targetFilter) {
      if (Array.isArray(targetFilter)) {
        return !!targetFilter.length;
      } else {
        return targetFilter;
      }
    }
    return false;
  };

  if (!filterOption || !values.length) {
    return null;
  }

  const renderPlaceholder = () => {
    let tempText = `Select ${label}`;
    let showDisabled = false;
    let cName = "reset-text";
    let showSelected = true;
    if (tempText == "Category") {
      tempText = "Theme";
    }
    if (isFilterPopulated()) {
      showSelected = false;
    } else {
      showDisabled = true;
    }

    return (
      <option
        disabled={showDisabled}
        selected={showSelected}
        className={cName}
        value="reset"
      >
        {tempText}
      </option>
    );
  };

  if (!multiselect) {
    return (
      <div className={`form-group ${disabled ? "disabled" : ""} `}>
        <div className="filterDiv filteInputText">
          <label>{label == "Category" ? toPascalCase("THEME") : label}</label>
          <select onChange={handleSelect} className="form-control">
            {renderPlaceholder()}
            {values &&
              values.map((opt) => {
                const {
                  edition_name,
                  id,
                  description,
                  type_name,
                  entity_name,
                  tone,
                  zone,
                  client_name,
                  text,
                  label,
                  country_name,
                  language_name,
                  channel_name,
                  anchor_name,
                  language,
                  state
                } = opt;

                const faceValue =
                  description ||
                  edition_name ||
                  type_name ||
                  entity_name ||
                  tone ||
                  zone ||
                  client_name ||
                  text ||
                  language_name ||
                  country_name || channel_name || anchor_name || language ||
                  label || 
                  state;

                const uid = uniqueId(id, faceValue);

                return (
                  <option
                    selected={handleSelectedOption(id, label)}
                    key={uid}
                    className="filterOption"
                  >
                    {faceValue}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    );
  }
  return (
    <React.Fragment>
      <div className={`form-group ${disabled ? "disabled" : ""} `}>
        <div className="filterDiv accordionDropdown">
          <div
            className="filterLabel"
            onClick={() => setSelectedFilter(isSelected ? undefined : name)}
          >
            <span>
              {name == "TONALITY_MULT"
                ? toPascalCase("SENTIMENT")
                : name == "Category"
                  ? toPascalCase("THEME")
                  : toPascalCase(name)}
            </span>
            {isSelected ? (
              <i className="icon">
                <RemoveIcon />
              </i>
            ) : (
              <i className="icon">
                <AddIcon />
              </i>
            )}
          </div>
          <ul
            name={name}
            className={`${isAddWidgetPage ? "addFiltersDropDown" : "filtersDropDown"
              } ${name} Filter ${isSelected ? "show" : "hide"} `}
          >
            {isFilterPopulated() && showNone && (
              <li
                onClick={() => handleFilterSelect(name, "", true)}
                className="reset-text"
              >
                None
              </li>
            )}
            {showSelectedAll && (
              <li onClick={handleSelectedAllClick} className="filterOption">
                <label className="inputWrap">
                  All
                  <input type="checkbox" checked={isSelectedAllChecked()} />
                  <span className="checkmark"></span>
                </label>
              </li>
            )}
            {values &&
              values.filter((data) => name === VERTICAL && ((data.id == VERTICALS.V_ONLINE && selectedClient.is_online_access == "0") || (data.id == VERTICALS.V_PRINT && selectedClient.is_print_access == "0"))?false:true).map(
                (
                  {
                    edition_name,
                    id,
                    description,
                    type_name,
                    entity_name,
                    tone,
                    zone,
                    client_name,
                    text,
                    label,
                    country_name,
                    language_name,
                    state
                  },
                  index
                ) => {
                  const faceValue =
                    description ||
                    edition_name ||
                    type_name ||
                    entity_name ||
                    tone ||
                    zone ||
                    client_name ||
                    text ||
                    country_name ||
                    language_name ||
                    label ||
                    state;

                  const uid = uniqueId(id, faceValue) + index;
                  const isElementSelected = isChecked(name, id);
                  return (
                    <li
                      onClick={() => {
                        handleFilterSelect(name, id);
                      }}
                      key={`${uid}-${isElementSelected} `}
                      className="filterOption"
                    >
                      <label className="inputWrap">
                        {
                          //https://webonise.atlassian.net/browse/CB-614
                          faceValue == "Informative" ? "Neutral" : faceValue
                        }
                        {<input type="checkbox" checked={isElementSelected} />}
                        <span className="checkmark"></span>
                      </label>
                    </li>
                  );
                }
              )}
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

FilterItem.defaultProps = {
  filterOption: {
    values: [],
    name: "",
    multiselect: false,
  },
  selectedFilter: "",
  setSelectedFilter: () => { },
};
